import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import WatchApp from '../../WatchApp';
import './AppSubscription.css';

const AppSubscription = ({ app }) => (
  <section className="app-subscription">
    <header className="app-subscription__header">
      <h3>
        <Link to={`/apps/${app.id}`}>{app.name}</Link>
      </h3>
      <p>{app.summary}</p>
    </header>
    <main className="app-subscription__body">
      <WatchApp app={app} />
    </main>
  </section>
);

AppSubscription.propTypes = {
  app: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isSubscribable: PropTypes.bool,
    subscriptionInfo: PropTypes.shape({
      inApp: PropTypes.bool
    })
  })
};

export default AppSubscription;
